import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaArrowRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const PortfolioSingle = () => {

  // Get Portfolio details passed via router state
  const location = useLocation();
  const portfolio = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={portfolio.title} page={"Portfolio Single"} />

      <section className='portfolio-single page-single'>

        <div className='portfolio-info page-info'>

          {/* Portfolio Image */}
          <div className='image'>
            <img src={portfolio.image} alt={portfolio.title} />
          </div>

          <div className='content'>

            {/* Portfolio Title */}
            <h3 className='main-heading'>{portfolio.title}</h3>

            {/* Portfolio Description */}
            {portfolio.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Portfolio Image Gallery */}
            <Lightbox images={portfolio.gallery} />

            {/* Services Offered */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Services Offered:</h3>
              <p>A breakdown of the planning and coordination services provided for the {portfolio.title} project.</p>

              {/* Services List */}
              <ul>
                {portfolio.services.map((service, index) => {
                  return <li key={index}> <div className='icon'><FaCheck  /></div> {service}</li>
                })}
              </ul>

            </div>

            {/* Event Highlights */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Event Highlights:</h3>
              <p>Unforgettable moments, creative ideas, and seamless execution that brought the {portfolio.title} event to life.</p>

              {/* Highlights List */}
              <ul>
                {portfolio.highlights.map((highlight, index) => {
                  return <li key={index}> <div className='icon'><FaArrowRight  /></div> {highlight}</li>
                })}
              </ul>

            </div>

            {/* Themes & Styles */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Themes & Styles:</h3>
              <p>Creative themes, personalized styles, and aesthetic touches that made the {portfolio.title} event a stunning and memorable celebration.</p>

              {/* Themes List */}
              <ul>
                {portfolio.themes.map((theme, index) => {
                  return <li key={index}> <div className='icon'><FaCircleNotch /></div> {theme}</li>
                })}
              </ul>

            </div>

          </div>

        </div>

        {/* Sidebar with Portfolio details */}
        <PageSidebar
          heading={'Portfolio'}
          details={portfolio.details}
        />

      </section>

    </> 
  );
}

export default PortfolioSingle;